/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from 'react-redux'
import { Layout, Menu, Modal } from 'antd'
import Link from './link'

import { withTrans } from '../i18n/withTrans'

import { HomeIcon, BookingIcon, HistoryIcon, PrivilegeIcon, MoreIcon, AlertIcon } from './icons'

import { custom as customStyle } from './../theme'
import { initSession } from '../services'
import { initUser, openLoading } from '../state/action'

import LoaderComponent from '../components/loader'
import exception from "../handlers/global-exception"
import { ga4 } from '../handlers/google-analytic'
import { initGa4, trackPage } from "../handlers/google-analytic"
import { getGG } from "../state/store"
import { initializeDatadog } from '../libs/datadog'
import { datadogRum } from '@datadog/browser-rum'


const { Footer, Content } = Layout

const handleMenu = async (menuName, menuBarButtonId, user) => {
  //if (ga4) {
  ga4.gtag("event", "menu_bar", {
    menu: menuName,
    category: 'menu_bar',
    trigger: menuBarButtonId,
    profile_id: user.profileId
  })
  // } else {
  //   console.error('GA4React is not initialized properly.')
  // }
}

class MainLayout extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      uniqueID: '', // Initialize state for uniqueID
    };
  }

  handleOk = e => {
    const { liff = {} } = window
    if (liff.closeWindow) {
      liff.closeWindow()
    } else {
    }
  }

  async componentDidMount() {


    const { initStatus: liffStatus, setUser, noLoading, onInitSuccess = () => { }, openInitializeLoading, openLoading, t } = this.props
    const accessToken = document.querySelector('meta[http-equiv="x-user-token"]').getAttribute('content')

    let envKWPP = '' // Initialize the variable

    if (typeof window !== 'undefined') {
      if (window.location.href.includes('test') || window.location.href.includes('localhost')) {
        envKWPP = 'uat'
      } else {
        envKWPP = 'production' // Default to production if no match
      }

      initializeDatadog(envKWPP) // Pass it to the initialization
    }
    const uniqueID = Math.random().toString(36).slice(2, 12);
    this.setState({ uniqueID })
    datadogRum.addAction('log_FE_init_'+ uniqueID + '_1', {
      message: ""
    })
    // get ga code
    const gaCode = document.querySelector('meta[http-equiv="ga-code"]').getAttribute('content')

    datadogRum.addAction('log_FE_init_'+ uniqueID + '_2', {
      message: ""
    })
    if (!liffStatus) {
      datadogRum.addAction('log_FE_liffStatus', {
        message: 'LiffStatus false'
      })

      openInitializeLoading(true)
    } else if (!noLoading) {
      datadogRum.addAction('log_FE_init_'+ uniqueID + '_3', {
        message: ""
      })
      openLoading(true)
    }
    datadogRum.addAction('log_FE_init_'+ uniqueID + '_4', {
      message: ""
    })
    if (!liffStatus) {
      datadogRum.addAction('log_FE_init_'+ uniqueID + '_5', {
        message: ""
      })
      // NOTE: init ga
      // if (!ga4) {
      //   await initGa4(gaCode) // Ensure initialization is complete
      // }
      await initGa4(gaCode)
      datadogRum.addAction('log_FE_init_'+ uniqueID + '_6', {
        message: ""
      })
      // NOTE: Comment the follow codes to disable line LIFF connection.
      // <--! starts from here -->
      const { liff = {} } = window
      datadogRum.addAction('log_FE_init_'+ uniqueID + '_7', {
        message: ""
      })
      const liffId = document.querySelector('meta[http-equiv="x-lineliff-token"]').getAttribute('content')
      datadogRum.addAction('log_FE_init_'+ uniqueID + '_8', {
        message: ""
      })
      try {
        datadogRum.addAction('log_FE_init_'+ uniqueID + '_9', {
          message: ""
        })
        await liff.init({ liffId })
        datadogRum.addAction('log_FE_init_'+ uniqueID + '_10', {
          message: liffId
        })
        // liff.init({
        //   liffId: document.querySelector('meta[http-equiv="x-lineliff-token"]').getAttribute('content')
        // })
        //   .then(() => {
        // Start to use liff's api
        if (liff.isInClient()) {
          datadogRum.addAction('log_FE_init_'+ uniqueID + '_11', {
            message: ""
          })
          const accessTokenLine = liff.getAccessToken()
          datadogRum.addAction('log_FE_init_'+ uniqueID + '_12', {
            message: ""
          })
          if (accessTokenLine) {
            // Log custom action in Datadog RUM
            datadogRum.addAction('api_init_request', {
              method: 'POST',
              url: '/lineliff/init',
              request: "{ lineUserID: '" + accessTokenLine + "', token: '" + accessToken + "' }",
            });

            initSession(accessTokenLine, accessToken) //api call
              .then((response) => {

                datadogRum.addAction('api_init_request_success_layout', {
                  method: 'POST',
                  url: '/lineliff/init',
                  request: "{ lineUserID: '" + accessTokenLine + "', token: '" + accessToken + "' }",
                  response: response
                })

                response.profileImage = ''
                response.profileName = ''

                liff.getProfile().then((profile) => {
                  datadogRum.addAction('log_FE_init_'+ uniqueID + '_13', {
                    message: ""
                  })
                  if (profile) {
                    datadogRum.addAction('log_FE_init_'+ uniqueID + '_14', {
                      message: ""
                    })
                    response.profileImage = profile.pictureUrl
                    response.profileName = profile.displayName

                    setUser(response)
                    datadogRum.addAction('log_FE_init_'+ uniqueID + '_15', {
                      message: ""
                    })
                    onInitSuccess()
                    datadogRum.addAction('log_FE_init_'+ uniqueID + '_16', {
                      message: ""
                    })

                  } else {
                    datadogRum.addError('error_FE_liff.getProfile', {
                      message: 'Failed to get profile'
                    })

                    exception('', t)
                    datadogRum.addAction('log_FE_init_'+ uniqueID + '_17', {
                      message: ""
                    })
                  }
                  openLoading(false)
                  datadogRum.addAction('log_FE_init_'+ uniqueID + '_18', {
                    message: ""
                  })

                }).catch((profileError) => {
                  datadogRum.addAction('log_FE_init_'+ uniqueID + '_19', {
                    message: ""
                  })
                  openLoading(false)
                  datadogRum.addAction('log_FE_init_'+ uniqueID + '_20', {
                    message: ""
                  })
                  exception(profileError, t, 'INIT')
                  datadogRum.addAction('log_FE_init_'+ uniqueID + '_21', {
                    message: ""
                  })
                })

              }).catch((err) => {
                datadogRum.addAction('log_FE_init_'+ uniqueID + '_22', {
                  message: ""
                })
                let responseMeta = ''

                // Check if error response contains the necessary data
                if (err && err.response && err.response.data && err.response.data.meta) {
                  datadogRum.addAction('log_FE_init_'+ uniqueID + '_23', {
                    message: ""
                  })
                  responseMeta = err.response.data.meta// Default to empty string if undefined
                }

                // Log the data to Datadog
                datadogRum.addAction('api_init_request_fail_layout', {
                  method: 'POST',
                  url: '/lineliff/init',
                  request: `{ lineUserID: '${accessTokenLine}', token: '${accessToken}' }`, // Template literals
                  response: err,
                  responseMeta: responseMeta
                })

                openLoading(false)
                datadogRum.addAction('log_FE_init_'+ uniqueID + '_24', {
                  message: ""
                })
                exception(err, t, 'INIT')
                datadogRum.addAction('log_FE_init_'+ uniqueID + '_25', {
                  message: ""
                })
              })
          } else {
            //console.error("Failed to get access token")
            // Handle the case where the access token is not available
            datadogRum.addError('error_FE_liff.getAccessToken', {
              message: 'Failed to get access token'
            });

            openLoading(false)
            datadogRum.addAction('log_FE_init_'+ uniqueID + '_26', {
              message: ""
            })
            Modal.error({
              icon: <div className={'modal-timeout-icon'}><AlertIcon /></div>,
              width: 300,
              content: <div className={'modal-custom-body-timeout'}>
                <div className={'modal-custom-title'}>
                  SORRY
                </div>
                <div>Failed to get access token</div>
              </div>,
              onOk: this.handleOk
            })
            datadogRum.addAction('log_FE_init_'+ uniqueID + '_27', {
              message: ""
            })
          }
          datadogRum.addAction('log_FE_init_'+ uniqueID + '_28', {
            message: ""
          })
          //initSession
        } else {
          datadogRum.addAction('log_FE_init_'+ uniqueID + '_29', {
            message: ""
          })
          openLoading(false)
          datadogRum.addAction('log_FE_init_'+ uniqueID + '_30', {
            message: ""
          })
          Modal.error({
            icon: <div className={'modal-timeout-icon'}><AlertIcon /></div>,
            width: 300,
            content: <div className={'modal-custom-body-timeout'}>
              <div className={'modal-custom-title'}>
                SORRY
              </div>
              <div>Please try again on Line browser...</div>
            </div>,
            onOk: this.handleOk
          })
          datadogRum.addAction('log_FE_init_'+ uniqueID + '_31', {
            message: ""
          })
        }
        // }).catch((err) => {

        //   openLoading(false)
        //   exception(err, t, 'INIT')
        // })

      } catch (initError) {
        datadogRum.addError('line_liff.init_fail', {
          error: initError
        })

        exception(initError, t, 'INIT')
        datadogRum.addAction('log_FE_init_'+ uniqueID + '_32', {
          message: ""
        })

      }
      datadogRum.addAction('log_FE_init_'+ uniqueID + '_33', {
        message: ""
      })
      trackPage({ profile_id: getGG().store.getState().user.profileId })
      datadogRum.addAction('log_FE_init_'+ uniqueID + '_34', {
        message: ""
      })
      // <--! and ends here -->

      // NOTE: Uncomment the follow codes to connect the mock server.
      // <--! starts from here -->
      // initSession('LineUUID01', accessToken)
      //   .then((response) => {
      //     setUser(response)
      //     onInitSuccess()
      //     openLoading(false)
      //   })
      //   .catch((err) => {
      //     openLoading(false)
      //     exception(err, t)
      //   })
      // <--! and ends here -->
    } else if (liffStatus) {
      datadogRum.addAction('log_FE_init_'+ uniqueID + '_35', {
        message: ""
      })
      onInitSuccess()
      datadogRum.addAction('log_FE_init_'+ uniqueID + '_36', {
        message: ""
      })
    }
    datadogRum.addAction('log_FE_init_'+ uniqueID + '_37', {
      message: ""
    })
  }

  render() {
    const { uniqueID } = this.state;
    const { children, className, hideMenu, isLoading, loaderType, t } = this.props

    const windowGlobal = typeof window !== 'undefined' && window
    const pathname = windowGlobal ? window.location.pathname : '/'
    const determineActiveClassName = (path) => pathname.indexOf(path) > -1 ? 'menu-active' : ''

    return (
      <Layout className={`wisdom-app ${className}`} style={{ height: '100vh' }}>
        {
          !isLoading &&
          <Content>
            {children}
            <div style={{ height: '80px' }} />
          </Content>
        }
        {
          !hideMenu && !isLoading ?
            <Footer>
              <Menu mode="horizontal" className={'wisdom-menu'} style={customStyle.menu}>
                <Menu.Item key="index" style={customStyle.menuItem} onClick={() => handleMenu('home', 'menu_bar_view_home_btn', this.props.user)} button_id="menu_bar_view_home_btn">
                  <Link to="/" style={customStyle.menuText} className={pathname === '/' ? 'menu-active' : ''}>
                    <HomeIcon />
                    <span>{t('menu_footer_home')}</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="privileges" style={customStyle.menuItem} onClick={() => handleMenu('privileges', 'menu_bar_view_privileges_btn', this.props.user)} button_id="menu_bar_view_privileges_btn">
                  <Link to="/privileges/" style={customStyle.menuText} className={determineActiveClassName('privileges')}>
                    <PrivilegeIcon />
                    <span>{t('menu_footer_privileges')}</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="history" style={customStyle.menuItem} onClick={() => handleMenu('history', 'menu_bar_view_history_btn', this.props.user)} button_id="menu_bar_view_history_btn">
                  <Link to="/redeem/history" style={customStyle.menuText} className={determineActiveClassName('redeem')} >
                    <HistoryIcon />
                    <span>{t('menu_footer_history')}</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="booking" style={customStyle.menuItem} onClick={() => handleMenu('booking', 'menu_bar_view_booking_btn', this.props.user)} button_id="menu_bar_view_booking_btn">
                  <Link to="/booking/list" style={customStyle.menuText} className={determineActiveClassName('booking')} >
                    <BookingIcon />
                    <span>{t('menu_footer_booking')}</span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="more" style={customStyle.menuItem} onClick={() => handleMenu('more', 'menu_bar_view_more_btn', this.props.user)} button_id="menu_bar_view_more_btn">
                  <Link to="/more/" button_id="More_View_btn" style={customStyle.menuText} className={determineActiveClassName('more')}>
                    <MoreIcon />
                    <span>{t('menu_footer_more')}</span>
                  </Link>
                </Menu.Item>
              </Menu>
            </Footer> : null
        }
        {
          isLoading && <div className={'main-loader'}>
            <LoaderComponent hasLogo={loaderType === 'initializing'} uniqueID={uniqueID}/>
          </div>
        }
      </Layout>
    )
  }
}

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

const mapStateToProps = ({ initStatus, user, isLoading, loaderType }) => ({
  initStatus,
  user,
  isLoading,
  loaderType
})

const mapDispatchToProps = (dispatch) => ({
  setUser: (user) => {
    dispatch(initUser(user))
  },
  openInitializeLoading(isLoading) {
    dispatch(openLoading(isLoading, 'initializing'))
  },
  openLoading(isLoading) {
    dispatch(openLoading(isLoading))
  },
})

export default withTrans(connect(mapStateToProps, mapDispatchToProps)(MainLayout))
